import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';
import { ImprovementProposal } from '../Model/ImprovementProposal';

// data puede contener: documents, workflowAction (approve|reject|close), rejectionReason, costIncrease, timeIncrease, costReduction, timeReduction
export async function patchImprovementProposal(id, data) {
  const response = await getAPIResponse(`/v1/improvement-proposal/${id}`, data, 'PATCH');
  if (response === null) return null;
  try {
    return ImprovementProposal.createFromResponseData(response);
  } catch (e) {
    return null;
  }
}
